import { _mjs } from "measurementjs";
import { Logger } from "./Logger";

export enum MeasurementEvents {
  DOC_CAP_CLICK_LAND = "DOC_CAP_CLICK_LAND",
  DOC_CAP_SCROLL_LAND = "DOC_CAP_SCROLL_LAND",
  DOC_CAP_BACK_LAND = "DOC_CAP_BACK_LAND",
  DOC_CAP_INACT_LAND = "DOC_CAP_INACT_LAND",
  DOC_CAP_ACT_LAND = "DOC_CAP_ACT_LAND",
  DOC_CAP_CAM_PROB = "DOC_CAP_CAM_PROB",
  DOC_CAP_MARB = "DOC_CAP_MARB",
  DOC_CAP_CAM_ACC = "DOC_CAP_CAM_ACC",
  DOC_CAP_LOG_OUT = "DOC_CAP_LOG_OUT",
  DOC_CAP_BAD_UUID = "DOC_CAP_BAD_UUID",
  DOC_CAP_BAU = "DOC_CAP_BAU",
  DOC_CAP_SWITCH_TO_SAFARI = "DOC_CAP_SWITCH_TO_SAFARI",
  DOC_CAP_LEAVE_EMBEDDED = "DOC_CAP_LEAVE_EMBEDDED",
  DOC_CAP_USER_MEDIA_MISSING = "DOC_CAP_USER_MEDIA_MISSING",
  DOC_CAP_USER_MEDIA_MISSING_POSS_EMBED = "DOC_CAP_USER_MEDIA_MISSING_POSS_EMBED",
  DOC_CAP_ANDROID_FORCE_MANUAL = "DOC_CAP_ANDROID_FORCE_MANUAL",
  DOC_CAP_IOS_FORCE_MANUAL = "DOC_CAP_IOS_FORCE_MANUAL",

  EV_ID_LAUNCH_VERIFF = "EV_ID_LAUNCH_VERIFF",
  EV_ID_VERIFF_RESULT = "EV_ID_VERIFF_RESULT",

  EV_ID_PRIMARY_VERIFF_NOT_SELECTED = "EV_ID_PRIMARY_VERIFF_NOT_SELECTED",
  EV_ID_COBORROWER_MANUAL_UPLOAD = "EV_ID_COBORROWER_MANUAL_UPLOAD",
  EV_ID_ESCAPE_HATCH = "EV_ID_ESCAPE_HATCH",
}

export interface MeasurementFireData {
  mjs_event: MeasurementEvents;
  mjs_value: string;
}

export interface MeasurementPrepareData {
  mjs_target_id: string;
  mjs_target_type: string;
}

export class Measurement {

  public static init() {
    _mjs.init({
      checkBeforeFire: false,
      enableGeolocation: false,
      isSinglePageApp: true,
      waitForPrepare: true,
    });
  }

  public static prepare = (appId: string | undefined, uuid: string | undefined) => {
    let targetId: string;
    let targetType: string;
    if (!!appId) {
      targetId = appId;
      targetType = "DOC_CAP_APP";
    } else if (!!uuid) {
      targetId = uuid;
      targetType = "DOC_CAP_UUID";
    } else {
      Logger.error("Unable to prepare Measurement");
      return;
    }

    const data: MeasurementPrepareData = {
      mjs_target_id: targetId,
      mjs_target_type: targetType,
    };

    _mjs.prepare(data);
  };

  public static mapObjectToValue(object: any | undefined): string {
    if(!object) {
      return "";
    }

    return _mjs.jsonToLiteral(object);
  }

  public static fireEvent = (event: MeasurementEvents, keys: any | undefined = {}) => {
    const data: MeasurementFireData = {
      mjs_event: event,
      mjs_value: Measurement.mapObjectToValue(keys),
    };

    try {
      _mjs.fire(data);
    } catch(err) {
      // o well, drop a measurement event but it will be ok.
    }
  };

  public static enqueueEvent = (event: MeasurementEvents, keys: any | undefined = {}) => {
    const data: MeasurementFireData = {
      mjs_event: event,
      mjs_value: Measurement.mapObjectToValue(keys),
    };
    try{
      _mjs.enqueue(data);
    } catch(err) {
      // o well, drop a measurement event but it will be ok.
    }
  }
}



// WEBPACK FOOTER //
// ./src/constants/Measurement.ts